// QuoteHeader.js — white ~80px page header for the quote builders. Quote ID
// (mono cobalt) + status pills + title on the left; action buttons (children)
// right-aligned. Replaces the dark KPI strip atop the quote pages. Faithful
// port of components/workspace/QuoteHeader.jsx.
import React from 'react';
import { v3 } from '../../lib/styleTokens';
import { Pill } from './Pill';

export function QuoteHeader({ id, title, status, statusVariant = 'amber', extraPills = [], savedLabel, children }) {
  return (
    <header
      style={{
        background: v3.color.card,
        borderBottom: `1px solid ${v3.color.border}`,
        padding: '20px 32px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        fontFamily: v3.font.family,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          {id && (
            <span
              style={{
                fontFamily: v3.font.mono,
                fontSize: v3.font.size.label,
                color: v3.color.ink,
                fontWeight: v3.font.weight.semibold,
              }}
            >
              {id}
            </span>
          )}
          {status && <Pill variant={statusVariant}>{status}</Pill>}
          {extraPills.map((p, i) => (
            <Pill key={i} variant={p.variant}>
              {p.label}
            </Pill>
          ))}
          {savedLabel && (
            <span style={{ fontSize: v3.font.size.small, color: v3.color.muted }}>{savedLabel}</span>
          )}
        </div>
        <h1
          style={{
            fontSize: v3.font.size.pageTitle,
            fontWeight: v3.font.weight.semibold,
            margin: 0,
            letterSpacing: v3.font.letterSpacing.tight,
            color: v3.color.body,
          }}
        >
          {title}
        </h1>
      </div>
      <div style={{ display: 'flex', gap: 8, flex: '0 0 auto' }}>{children}</div>
    </header>
  );
}
